<template>
	<div>
		<div>
			<div style="color: #3e3e3e;font-size: 18px;margin-bottom: 15px;">营销管理>券包设置</div>
			<div class="title1">
				<div class="left">
					<!-- <el-select v-model="filter.status" style="width: 150px;margin-right: 20px;" size="small">
						<el-option v-for="item in activeStateList" :key="item.value" :label="item.label" :value="item.value">
						</el-option>
					</el-select> -->
					<el-select clearable class="jul" size="small" v-model="filter.type" placeholder="全部类型">
						<el-option v-for="item in statelist" :key="item.value" :label="item.label"
							:value="item.value"></el-option>
					</el-select>
					<el-input clearable type="text" v-model="filter.name" placeholder="请输入券包名称"
						style="width: 200px;margin-right: 20px;" size="small"></el-input>
					<el-select clearable class="jul" size="small" v-model="filter.label" placeholder="券包标签">
						<el-option v-for="item in labels" :key="item.value" :label="item.label"
							:value="item.value"></el-option>
					</el-select>
					<el-select clearable class="jul" size="small" v-model="filter.status" placeholder="券包状态">
						<el-option v-for="item in storeval" :key="item.value" :label="item.label"
							:value="item.value"></el-option>
					</el-select>
					<el-button type="primary" size="small" @click="getvolumelist()">筛选</el-button>
					<el-button type="primary" size="small" @click="addvolum()">新建卷包</el-button>
				</div>
			</div>
			<!-- <div style="margin-top:10px;">
				<el-radio-group size="small" v-model="filter.overdue">
					<el-radio-button label="0">进行中</el-radio-button>
					<el-radio-button label="1">已过期</el-radio-button>
				</el-radio-group>
			</div> -->
			<div style="margin-top:15px">
				<el-table :data="exchangeCodeList" style="width: 100%"
					:header-cell-style="{background:'#F2F2F4','text-align':'center'}">
					<el-table-column prop="id" align="center" width="200" label="券包ID"></el-table-column>
					<el-table-column label="名称" prop="name" align="center"></el-table-column>
					<el-table-column label="类型" prop="type" align="center" width="200">
						<template slot-scope="scope">
							{{ scope.row.type | typeFormat }}
						</template>
					</el-table-column>
					<el-table-column prop="price" align="center" width="200" label="价格">
						<template slot-scope="scope">
							{{ (scope.row.price/100).toFixed(2) }}
						</template>
					</el-table-column>
					<el-table-column label="兑换积分数" prop="integral" align="center" width="200"></el-table-column>
					<el-table-column label="每人限购次数" prop="count" align="center" width="200"></el-table-column>
					<!-- <el-table-column align="center" label="有效期" width="200">
						<template slot-scope="scope">
							{{scope.row.sameDay ==null? scope.row.startTime+"至"+scope.row.endTime : "领取后" + scope.row.sameDay +"天有效"}}
						</template>
					</el-table-column> -->
					<!-- <el-table-column align="center" label="已领取">
						<template slot-scope="scope">
							{{scope.row.receive?scope.row.receive:0}}
						</template>
					</el-table-column> -->
					<el-table-column label="操作" align="center" width="200">
						<template slot-scope="{row}">
							<!-- 							<p>
								{{scope.row.status==0?"未开始":""}}
								{{scope.row.status==1?"进行中":""}}
								{{scope.row.status==2?"已结束":""}}
								{{scope.row.status==3?"已失效":""}}
							</p> -->
							<!-- <el-button type="text" @click="dialog_touf=true">定向发送</el-button> -->
							<el-button type="text" @click="addvolum(row.id)">编辑</el-button>
							<!-- <el-button type="text" @click="dialog_tuig = true">推广</el-button> -->
							<!-- <el-button type="text" @click="delit(row.id)">编辑</el-button> -->
							<el-button type="text" @click="updown(row.id, row.status==0?1:0)" style="color:#e36">
								{{row.status==0?"上架":"下架"}}
							</el-button>
							<el-button type="text" @click="volumclear(row.id)"><span
									style="color: red;">删除</span></el-button>
							<!-- <el-button type="text">复制</el-button> -->
						</template>
					</el-table-column>
				</el-table>
			</div>
			<!-- 推广 -->
			<el-dialog :visible.sync="dialog_tuig" width="25%">
				<div class="dia_title">优惠券H5</div>
				<div class="erwei">
					<img
						src="https://lanhu.oss-cn-beijing.aliyuncs.com/ps1eb15cb7c10e81b9-5a84-438d-b0da-0865ed2f6393" />
				</div>
				<div>
					<div class="downerwei" @click="downloadCodeImg(img)">
						下载二维码
					</div>
				</div>
				<section class="form">
					<el-input :disabled="true" size="small" v-model="cjurl" style="width: 252px;margin-left:50px;margin-top: 20px;
				 margin-bottom:30px;"></el-input>
					<span slot="footer" class="dialog-footer">
						<el-button type="primary" v-clipboard:copy="cjurl" v-clipboard:success="onCopy"
							v-clipboard:error="onError" @click="dialog_tuig = copy">复制</el-button>
					</span>
				</section>
			</el-dialog>
			<!-- 定向投放 -->
			<el-dialog :visible.sync="dialog_touf" width="50%">
				<div class="title" style="margin-top:-43px;">
					<div class="blue"></div>
					<div style="flex: 1;">运营计划管理</div>
				</div>
				<el-form label-width="80px">
					<el-form-item label="选择用户">
						<el-radio v-model="chooseruser" value="1" label="全部用户"></el-radio>
						<el-radio v-model="chooseruser" value="2" label="指定用户群体"></el-radio>
					</el-form-item>
					<el-form-item label="选择用户">
						<div class="boton">
							<div class="boton1">
								<div class="boton1_title" @click="dialog_shangzhi=true">+添加商品用户</div>
								<div class="botonlist">
									高活跃用户
									<div @click="clear_bon">×</div>
								</div>
							</div>
							<div class="boton1">
								<div class="boton1_title" @click="dialog_user=true">+指定用户群</div>
								<div class="botonlist">
									高活跃用户
									<div @click="clear_bon">×</div>
								</div>
							</div>
							<div class="duo">
								可多选
							</div>
						</div>
					</el-form-item>
					<el-form-item label="推送时间">
						<div class="bon_data">
							<el-date-picker size="small" v-model="time1" type="datetime"
								placeholder="选择日期时间"></el-date-picker>
							<div>至</div>
							<el-date-picker size="small" v-model="time2" type="datetime"
								placeholder="选择日期时间"></el-date-picker>
						</div>
						<div class="lastbottom">
							<el-button size="small" @click="dialog_touf=false">取 消</el-button>
							<el-button type="primary" size="small">确 定</el-button>
						</div>
					</el-form-item>
				</el-form>
			</el-dialog>
			<!-- 定向投放 -->
			<div class="lastdig">
				<el-dialog :visible.sync="dialog_user" width="50%">
					<div class="tanchutitle">添加用户群</div>
					<el-table :height="300" :data="tableData_1" style="width: 100%">
						<el-table-column prop="date" label="选择">
							<template slot-scope="scope">
								<el-checkbox :key="scope.row.id"></el-checkbox>
							</template>
						</el-table-column>
						<el-table-column prop="name" label="群名称"></el-table-column>
					</el-table>
					<div class="lastbottom" style="margin-left: 38%;">
						<el-button size="small" @click="dialog_user=false">取 消</el-button>
						<el-button type="primary" size="small">确 定</el-button>
					</div>
				</el-dialog>
			</div>
			<!-- 添加商品用户/指定用户 -->
			<div class="lastdig">
				<el-dialog :visible.sync="dialog_shangzhi" width="40%">
					<div style="margin-top: -40px;">
						<el-tabs type="card">
							<el-tab-pane label="剪发服务">
								<el-checkbox-group v-model="checkList">
									<el-table :height="300" :data="tableData_1" style="width: 100%">
										<el-table-column prop="date" label="选择">
											<template slot-scope="scope">
												<el-checkbox :key="scope.row.id"></el-checkbox>
											</template>
										</el-table-column>
										<el-table-column prop="name" label="姓名"></el-table-column>
										<el-table-column prop="address" label="地址"></el-table-column>
									</el-table>
								</el-checkbox-group>
							</el-tab-pane>
							<el-tab-pane label="商城商品">
								<el-table :height="300" :data="tableData_1" style="width: 100%">
									<el-table-column prop="date" label="选择">
										<template slot-scope="scope">
											<el-checkbox :key="scope.row.id"></el-checkbox>
										</template>
									</el-table-column>
									<el-table-column prop="name" label="姓名"></el-table-column>
									<el-table-column prop="address" label="地址"></el-table-column>
								</el-table>
							</el-tab-pane>
							<el-tab-pane label="会员">
								<el-table :height="300" :data="tableData_1" style="width: 100%">
									<el-table-column prop="date" label="选择">
										<template slot-scope="scope">
											<el-checkbox :key="scope.row.id"></el-checkbox>
										</template>
									</el-table-column>
									<el-table-column prop="name" label="姓名"></el-table-column>
									<el-table-column prop="address" label="地址"></el-table-column>
								</el-table>
							</el-tab-pane>
						</el-tabs>
					</div>
					<div class="mybotton">
						<el-button size="small" @click="dialog_shangzhi=false">取消</el-button>
						<el-button type="primary" size="small">保存</el-button>
					</div>
				</el-dialog>
			</div>

		</div>
		<div class="turnwai">
			<div class="turn">
				<!-- <el-pagination  background style="margin-top: 30px;" layout="total, sizes, prev, pager, next, jumper"
				:page-count="filter.pageNum"
				:page-size="filter.pageSize"
				 :total="200">
				</el-pagination> -->
				<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
					:current-page="filter.pageNum" :page-sizes="[10,15,20,30]" :page-size="filter.pageSize"
					layout="total, sizes, prev, pager, next, jumper" :total="filter.total">
				</el-pagination>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				total: 0,
				filter: {
					pageNum: 1, // 页码
					pageSize: 20, // 条数
					name: "", // 劵包名
					status: "", // 状态0未开始1进行中2已结束3已失效
					label: "",
					type: "",
					// overdue: 0,
					total: 0,
				},
				activeStateList: [{
					value: 0,
					label: "未开始"
				}, {
					value: 1,
					label: "进行中"
				}, {
					value: 2,
					label: "已结束"
				}, {
					value: 3,
					label: "已失效"
				}],
				exchangeCodeList: [],
				dialog_tuig: false,
				dialog_user: false,
				cjurl: "https://lanhu.oss-cn-beijing.aliyuncs.com/ps1eb15cb7c10e81b9-5a84-438d-b0da-0865ed2f6393",
				img: 'https://lanhu.oss-cn-beijing.aliyuncs.com/ps1eb15cb7c10e81b9-5a84-438d-b0da-0865ed2f6393',
				// 定向投放
				dialog_touf: false,
				// chooseruser
				chooseruser: "",
				time1: "",
				time2: "",
				//添加商品用户
				dialog_shangzhi: false,
				storeval: [{
					label: "全部状态",
					value: 1,
				}, {
					label: "未开始",
					value: 2,
				}, {
					label: "进行中",
					value: 3,
				}, {
					label: "已开始",
					value: 4,
				}, {
					label: "已经失效",
					value: 5,
				}],
				labels: [{
					label: "新品",
					value: 0,
				}, {
					label: "热销",
					value: 1,
				}, {
					label: "经典",
					value: 2,
				}],
				statelist: [
					// {
					// 	label: "满减券",
					// 	value: 0,
					// },
					// {
					// 	label: "折扣券",
					// 	value: 1,
					// },
					// {
					// 	label: "商品券",
					// 	value: 2,
					// },
					// {
					// 	label: "积分券",
					// 	value: 3,
					// },

					{
						label: "满减券",
						value: 0,
					}, {
						label: "实物兑换",
						value: 1,
					}, {
						label: "充值商品兑换",
						value: 2,
					}, {
						label: "组合",
						value: 3,
					},
				],
				currentPage4: 4,
				tableData_1: [],
				checkList: [],
			}
		},
		mounted() {
			this.getvolumelist()
		},
		watch: {
			filter: { //深度监听，可监听到对象、数组的变化
				handler(val, oldVal) {
					this.getvolumelist()
				},
				deep: true
			},
		},
		filters: {
			typeFormat(val) {
				switch (val) {
					case 0:
						return "满减券";
					case 1:
						return "实物兑换";
					case 2:
						return "充值商品兑换";
					case 3:
						return "组合";
					default:
						return "/";
				}
			},
		},
		methods: {
			// 停止
			volumstop(id) {
				let arr = {
					id: id
				}
				this.$http.post("couponPackage/stopCouponPackage", JSON.stringify(arr)).then(function(res) {
					if (res.body.code == 200) {
						this.getvolumelist()
						// this.exchangeCodeList=res.body.data
					}
				})
			},
			// 上架下架
			updown(id, state) {
				let data = {
					id: id,
					state: state,
				}
				this.$http.post("dhaircut/shelfService", JSON.stringify(data)).then(res => {
					if (res.body.code != 200) {
						this.$message.error(res.body.msg);
					} else {
						// this.getlist()
						this.getvolumelist()
						this.$message.success("上架/下架成功！");
					}
				})
			},
			//删除
			volumclear(id) {
				let arr = {
					id: id
				}
				this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$http.post("couponPackage/delCouponPackage", JSON.stringify(arr)).then(function(res) {
						if (res.body.code == 200) {
							this.$message({
								type: 'success',
								message: '删除成功!'
							});
							this.getvolumelist()
						} else {
							this.$message({
								type: 'error',
								message: res.body.msg
							});
						}
					}, function(err) {
						this.$message.error("请求失败")
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});

			},
			addvolum(id) {
				if (id) {
					this.$router.push({
						path: "/newcoupons",
						query: {
							id: id
						}
					})
				} else {
					this.$router.push({
						path: "/newcoupons"
					})
				}
			},
			getvolumelist() {
				this.$http.post("couponPackage/findDCouponPackage", JSON.stringify(this.filter)).then(function(res) {
					if (res.body.code == 200) {
						this.exchangeCodeList = res.body.data
						this.filter.total = res.body.total
					}
				}, function(err) {
					this.$message.error("请求失败")
				})
			},
			//复制路劲
			onCopy() {
				this.$message({
					message: `复制成功！`,
					type: 'success'
				});
				this.snackBar.info(this.$t('prompt.copySuccess'))
			},
			onError() {
				this.$message.error(this.$t('prompt.copyFail'))
			},
			clear_bon() {
				this.$confirm('是否要删除?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$message({
						type: 'success',
						message: '删除成功!'
					});
				});
			},
			handleSizeChange(val) {
				this.filter.pageSize = val
				this.getvolumelist()
			},
			handleCurrentChange(val) {
				this.filter.pageNum = val
				this.getvolumelist()
			}
		}
	}
</script>

<style lang="less" scoped>
	p {
		padding: 0;
		margin: 0;
	}

	.title1 {
		width: 100%;

		.left {
			float: left;
		}

		.right {
			float: right;
		}

		&::after {
			content: "";
			width: 1px;
			display: block;
			clear: both;
		}
	}

	.tanchutitle {
		margin-top: -30px;
		width: 100%;
		height: 42px;
		line-height: 42px;
		background-color: #F2F2F2;
		font-size: 16px;
		font-family: Source Han Sans CN;
		font-weight: 400;
		color: #888888;
		box-sizing: border-box;
		padding-left: 10px;

	}

	.title {
		font-size: 16px;
		font-family: Source Han Sans CN;
		font-weight: 400;
		color: #3E3E3E;
		display: flex;
		font-weight: bold;
		margin-bottom: 10px;

		.blue {
			width: 5px;
			height: 15px;
			background: #409EFF;
			border-radius: 2px;
			margin-right: 8px;
			position: relative;
			top: 4px;
		}
	}

	// 弹出框内容
	.dia_title {
		width: 100%;
		text-align: center;
		font-size: 18px;
		font-family: Source Han Sans CN;
		font-weight: 400;
		color: #525252;
	}

	.erwei {
		width: 157px;
		height: 157px;
		margin: 20px auto;

		img {
			width: 100%;
			height: 100%;
		}
	}

	.downerwei {
		cursor: pointer;
		width: 100%;
		text-align: center;
		font-size: 18px;
		font-family: Source Han Sans CN;
		font-weight: 400;
		color: #409EFF;
	}

	.dialog-footer {
		margin-top: -10px;
		margin-bottom: 20px;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		align-items: center;
	}

	.first_line {
		margin: 20px 0;
		display: flex;
		justify-content: space-between;

		.right_warp {
			display: flex;
			align-items: center;
			font-size: 16px;
			color: #3e3e3e;

			.el-select {
				width: 120px;
			}

			.el-input {
				width: 180px;
			}

			.jul {
				margin-left: 10px;
			}
		}
	}

	.pagescg {
		margin-top: 20px;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		align-items: center;
	}

	// 
	.boton {
		display: flex;

		>div {
			margin-right: 15px;
			flex-wrap: wrap;

			.boton1_title {
				cursor: pointer;
				height: 32px;
				padding-left: 8px;
				padding-right: 8px;
				border: 1px dashed #D9DCE3;
				border-radius: 4px;
				font-size: 14px;
				font-family: Source Han Sans CN;
				font-weight: 400;
				color: #959595;
				line-height: 32px;
				text-align: center;
			}

			.botonlist {
				margin-top: 15px;
				text-align: center;
				line-height: 32px;
				font-size: 14px;
				font-family: Source Han Sans CN;
				font-weight: 400;
				color: #959595;
				width: 99px;
				height: 32px;
				border: 1px solid #D9DCE3;
				border-radius: 4px;
				position: relative;

				div {
					cursor: pointer;
					line-height: 15px;
					position: absolute;
					width: 16px;
					height: 16px;
					background-color: black;
					color: white;
					border-radius: 50%;
					font-size: 14px;
					right: -8px;
					top: -8px;
				}
			}
		}

	}

	.bon_data {
		display: flex;

		div {
			padding-left: 5px;
			padding-right: 5px;
		}
	}

	.lastbottom {
		width: 138px;
		margin-left: 29%;
		margin-top: 25px;
	}

	.duo {
		font-size: 16px;
		font-family: Source Han Sans CN;
		font-weight: 400;
		color: #959595;
		opacity: 0.51;
		margin-top: -4px;
	}

	.lastdig {
		/deep/.el-dialog__close {
			display: none;
		}

		.mybotton {
			margin-left: 39%;
			margin-top: 15px;
		}
	}

	.turnwai {
		margin-top: 20px;
		width: 100%;
		height: 25px;
	}

	.turn {
		margin-left: 15%;
	}
</style>